<template>
  <section class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">
              <b>Novo Boleto Avulso</b>
            </h3>
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-sm-3">
                <div :class="{'form-group': true, 'has-error':errors.has('vencimento') }">
                  <label for="vencimento">Vencimento</label>
                  <input
                    class="form-control"
                    name="vencimento"
                    type="date"
                    v-model="dados.vencimento"
                    v-validate="'required'"
                  />
                  <span v-show="errors.has('vencimento')" class="help-block">Campo obrigatório</span>
                </div>
              </div>
              <div class="col-sm-2">
                <div :class="{'form-group': true, 'has-error':errors.has('valor') }">
                  <label>Valor</label>
                  <money
                    class="form-control solicitacao-dados"
                    v-model="dados.valor"
                    v-bind="money"
                  ></money>
                </div>
              </div>

              <div class="col-sm-2">
                <div :class="{'form-group': true, 'has-error':errors.has('cpf_cnpj') }">
                  <label for="cpf_cnpj" style>CPF/CNPJ</label>
                  <input
                    v-mask="['###.###.###-##','##.###.###/####-##']"
                    class="form-control"
                    name="cpf_cnpj"
                    type="text"
                    v-model="dados.cpf_cnpj"
                    @blur="preencheFormulario"
                  />
                </div>
              </div>
              <div class="col-sm-5">
                <div :class="{'form-group': true, 'has-error':errors.has('nome_razao') }">
                  <label for="nome_razao">Nome/Razão</label>
                  <input
                    class="form-control"
                    name="nome_razao"
                    type="text"
                    v-model="dados.nome_razao"
                    v-validate="'required'"
                    ref="nome_razao"
                  />
                  <span v-show="errors.has('nome_razao')" class="help-block">Campo obrigatório</span>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-2">
                <div :class="{'form-group': true, 'has-error':errors.has('cep') }">
                  <label for="cep">CEP</label>
                  <input
                    class="form-control"
                    name="cep"
                    type="text"
                    v-model="dados.cep"
                    v-validate="'required'"
                    v-mask="'#####-###'"
                    ref="cep"
                    @blur="getEndereco()"
                  />
                  <span v-show="errors.has('cep')" class="help-block">Campo obrigatório</span>
                </div>
              </div>

              <div class="col-sm-5">
                <div :class="{'form-group': true, 'has-error':errors.has('endereco') }">
                  <label for="endereco">Endereço</label>
                  <input
                    class="form-control"
                    name="endereco"
                    type="text"
                    v-model="dados.endereco"
                    v-validate="'required'"
                  />
                  <span v-show="errors.has('endereco')" class="help-block">Campo obrigatório</span>
                </div>
              </div>

              <div class="col-sm-2">
                <div :class="{'form-group': true, 'has-error':errors.has('numero') }">
                  <label for="numero">Número</label>
                  <input
                    class="form-control"
                    name="numero"
                    type="text"
                    v-model="dados.numero"
                    v-validate="'required'"
                    ref="numero_endereco"
                  />
                  <span v-show="errors.has('numero')" class="help-block">Campo obrigatório</span>
                </div>
              </div>
              <div class="col-sm-3">
                <div :class="{'form-group': true, 'has-error':errors.has('complemento') }">
                  <label for="complemento">Complemento</label>
                  <input
                    class="form-control"
                    name="complemento"
                    type="text"
                    v-model="dados.complemento"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-5">
                <div :class="{'form-group': true, 'has-error':errors.has('bairro') }">
                  <label for="bairro">Bairro</label>
                  <input
                    class="form-control"
                    name="bairro"
                    type="text"
                    v-model="dados.bairro"
                    v-validate="'required'"
                  />
                  <span v-show="errors.has('bairro')" class="help-block">Campo obrigatório</span>
                </div>
              </div>

              <div class="col-sm-5">
                <div :class="{'form-group': true, 'has-error':errors.has('cidade') }">
                  <label for="cidade">Cidade</label>
                  <input
                    class="form-control"
                    name="cidade"
                    type="text"
                    v-model="dados.cidade"
                    v-validate="'required'"
                    :disabled="true"
                  />
                  <span v-show="errors.has('cidade')" class="help-block">Cidade</span>
                </div>
              </div>

              <div class="col-sm-2">
                <div :class="{'form-group': true, 'has-error':errors.has('uf') }">
                  <label for="uf">Estado</label>
                  <input
                    class="form-control"
                    name="uf"
                    type="text"
                    v-model="dados.uf"
                    v-validate="'required'"
                    :disabled="true"
                  />
                  <span v-show="errors.has('uf')" class="help-block">Campo obrigatório</span>
                </div>
              </div>
            </div>
          </div>
          <div class="box-footer text-right">
            <router-link
              tag="button"
              to="/financeiro/boletos-avulsos"
              class="btn btn-default"
            >Cancelar</router-link>
            <button class="btn btn-primary" @click="salvar()">Salvar</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from "axios"; // Cliente para requisição http
import { mask } from "vue-the-mask";
import vSelect from "vue-select";
import { Money } from "v-money";

export default {
  directives: { mask },
  data() {
    return {
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      },
      taxa: {
        decimal: ".",
        thousands: "",
        prefix: "",
        precision: 2,
        masked: false
      },
      dados: {
        cpf_cnpj: "",
        nome_razao: "",
        cep: "",
        endereco: "",
        numero: "",
        complemento: "",
        bairro: "",
        cidade: "",
        uf: "",
        valor: "",
        vencimento: ""
      }
    };
  },
  mounted() {
    this.$nextTick(() => {
      // this.$refs.consulta_cpf_cnpj.focus();
    });

    if (this.$route.params.idEmpresa) {
      this.getById(this.$route.params.idEmpresa);
      this.atualizacao = true;
    }
  },

  methods: {
    salvar() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$store.commit("TOGGLE_LOADING");
          axios
            .post(
              `${this.$store.state.serverURI}/api/boletoAvulso/create`,
              this.dados,
              this.$store.getters.getHeaderAuth
            )
            .then(response => {
              this.$store.commit("SHOW_ALERT_SUCCESS");
              this.$swal({
                type: response.data.status == 200 ? "success" : "error",
                title:
                  response.data.status == 200
                    ? "Tudo Certo!"
                    : "Ops! Ocorreu um erro.",
                text: response.data.msg,
                showConfirmButton: false,
                timer: 1500
              });
              this.$router.push("/financeiro/boletos-avulsos");
            })
            .catch(error => {
              this.$store.commit("SHOW_ALERT_ERROR");
              console.log(error);
            });
        }
        this.$store.commit("TOGGLE_LOADING");
        return false;
      });
    },
    preencheFormulario() {
      let config = this.$store.getters.getHeaderAuth;
      config.params = { cpf_cnpj: this.dados.cpf_cnpj };
      axios
        .get(
          `${this.$store.state.serverURI}/api/boletoAvulso/getByCpfCnpj`,
          config
        )
        .then(response => {
          if (response.data) {
            this.dados.nome_razao = response.data.nome_razao;
            this.dados.cep = response.data.cep;
            this.dados.endereco = response.data.endereco;
            this.dados.numero = response.data.numero;
            this.dados.bairro = response.data.bairro;
            this.dados.cidade = response.data.cidade;
            this.dados.complemento = response.data.complemento;
            this.dados.uf = response.data.uf;
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    getEndereco() {
      if (this.dados.cep && this.dados.cep != "") {
        this.$store.commit("TOGGLE_LOADING");
        axios
          .get(`https://viacep.com.br/ws/${this.dados.cep}/json/`)
          .then(response => {
            if (response.data.erro) {
              this.$swal({
                type: "warning",
                title: "Digite um CEP válido!",
                text: ""
              }).then(() => {
                this.dados.cep = "";
                this.dados.endereco = "";
                this.dados.bairro = "";
                this.dados.cidade = "";
                this.dados.uf = "";
                this.$refs.cep.focus();
              });
              return false;
            }

            this.dados.endereco = response.data.logradouro;
            this.dados.bairro = response.data.bairro;
            this.dados.cidade = response.data.localidade;
            this.dados.uf = response.data.uf;
            this.$store.commit("TOGGLE_LOADING");

            this.$refs.numero_endereco.focus();
          })
          .catch(e => {
            console.log(e);
            this.$swal({
              type: "warning",
              title: "Não conseguimos buscar seu endereço!",
              text: "Por favor, digite um CEP válido!"
            });
          });
      }
    }
  },
  watch: {},
  components: {
    vSelect,
    Money
  }
};
</script>
<style scoped>
input {
  text-transform: uppercase;
}
</style>


// WEBPACK FOOTER //
// form.vue?721b3ce0